import { render, staticRenderFns } from "./VLibras.vue?vue&type=template&id=0daaf8a8&scoped=true&"
import script from "./VLibras.vue?vue&type=script&lang=js&"
export * from "./VLibras.vue?vue&type=script&lang=js&"
import style0 from "./VLibras.vue?vue&type=style&index=0&id=0daaf8a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daaf8a8",
  null
  
)

export default component.exports